/* Keep collection/search controls below the header that is actually on screen. */
(() => {
  const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const streamer = document.getElementById('shopify-section-top-streamer');
  const backToTop = document.querySelector('.back-to-top--results');
  let frame;
  let transitioning = false;
  let drawerOpen = false;

  function visibleBottom(element) {
    if (!element || !element.getClientRects().length) return 0;
    const rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight ? rect.bottom : 0;
  }

  function update() {
    frame = null;
    // Opening the drawer fixes the body and temporarily changes header geometry.
    if (drawerOpen) return;
    const edge = Math.max(0, visibleBottom(header), visibleBottom(streamer));
    root.style.setProperty('--oztrail-plp-sticky-edge', `${edge}px`);
    const grid = document.querySelector('.ais-results-size-lg .ais-hits-container, .ais-results-size-md .ais-hits-container');
    if (backToTop && grid) {
      const rect = grid.getBoundingClientRect();
      backToTop.style.setProperty('--plp-results-center', `${rect.left + rect.width / 2}px`);
    }
    if (transitioning) schedule();
  }

  function schedule() {
    if (frame == null) frame = window.requestAnimationFrame(update);
  }

  function trackTransition(event) {
    if (event.target !== header || event.propertyName !== 'top') return;
    transitioning = event.type === 'transitionrun';
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('algolia.instantSearch.afterInit', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('scroll', schedule);
  document.addEventListener('oztrail:algolia:filters-opened', () => { drawerOpen = true; });
  document.addEventListener('oztrail:algolia:filters-closed', () => {
    drawerOpen = false;
    schedule();
  });
  header?.addEventListener('transitionrun', trackTransition);
  header?.addEventListener('transitionend', trackTransition);
  header?.addEventListener('transitioncancel', trackTransition);

  if (typeof window.ResizeObserver === 'function') {
    const observer = new window.ResizeObserver(schedule);
    if (header) observer.observe(header);
    if (streamer) observer.observe(streamer);
  }
  const observer = new window.MutationObserver(schedule);
  if (header) observer.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
  if (streamer) observer.observe(streamer, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
  update();
})();
